import { render, staticRenderFns } from "./investor-banner.vue?vue&type=template&id=ef2f17e6&"
import script from "./investor-banner.vue?vue&type=script&lang=js&"
export * from "./investor-banner.vue?vue&type=script&lang=js&"
import style0 from "./investor-banner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports